import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=05c567d6&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "./orderList.vue?vue&type=style&index=0&id=05c567d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c567d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c567d6')) {
      api.createRecord('05c567d6', component.options)
    } else {
      api.reload('05c567d6', component.options)
    }
    module.hot.accept("./orderList.vue?vue&type=template&id=05c567d6&scoped=true", function () {
      api.rerender('05c567d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/tab4/orderList.vue"
export default component.exports